import { render } from "./chathistorymessages.vue?vue&type=template&id=32bb9c75&scoped=true"
import script from "./chathistorymessages.vue?vue&type=script&lang=js"
export * from "./chathistorymessages.vue?vue&type=script&lang=js"

import "./chathistorymessages.vue?vue&type=style&index=0&id=32bb9c75&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb9c75"]])

export default __exports__